import { FileArrowLeftRightIcon } from './FileArrowLeftRightIcon';

/**
 * author: Colton Wiscombe
 * id 05D3C734-5B81-429E-8D2D-45E1AF5CD6A7
 * name file-arrow-left-right
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file-arrow-left-right.svg
 * tags
 * - Files / Folders 
 */
export const FileTransferIcon = FileArrowLeftRightIcon;
export default FileTransferIcon